import { apiClient } from '../../../api/client'
import type {
  DeadlineRequest,
  DeadlineRequestApproveInput,
  DeadlineRequestCreateInput,
  DeadlineRequestRejectInput,
  DeadlineRequestStatusOption,
  DeadlineRequestTab,
  PagedResponse,
} from '../types'

const BASE = '/management/deadline-update-requests'

/**
 * Liste filtreleri (087). Hepsi sunucuda **VE** mantığıyla birleşir.
 *
 * <p><b>Kapsamı genişletecek bir parametre YOKTUR</b>: kimin hangi satırı gördüğü sunucuda, sorgunun
 * kendisinde belirlenir. `tab` bir istisna **değildir** — iki sekmenin ikisi de eski tek-liste
 * kapsamının (kendi talepleri ∪ kendisine düşenler) **alt kümesidir**, yani sekme daraltır, açmaz;
 * ayrıcalıklı yetkilinin tümünü görmesi de yine sunucudaki yetki kontrolüne bağlıdır.
 */
export interface DeadlineRequestFilters {
  /** Hangi sekme — kapsam daraltması (`MINE` kendi talepleri, `INBOX` kendisine düşen onaylar). */
  tab: DeadlineRequestTab
  /** Aksiyon adı veya gerekçe araması; `searchTerm` ile kapılanır (< 2 karakter gönderilmez). */
  q?: string
  /** Talep durumu (400/401/402); `null` → filtresiz. */
  statusId?: number | null
}

export interface DeadlineRequestQuery extends DeadlineRequestFilters {
  page: number
  size: number
}

/** Boş filtreler `undefined` olur → axios onları sorguya eklemez. `tab` her zaman gönderilir. */
function toParams(filters: DeadlineRequestFilters) {
  return {
    tab: filters.tab,
    q: filters.q ? filters.q : undefined,
    statusId: filters.statusId ?? undefined,
  }
}

/** Sayfalı talep listesi (görünürlük sunucuda daraltılır). */
export async function getDeadlineRequests(
  query: DeadlineRequestQuery,
): Promise<PagedResponse<DeadlineRequest>> {
  const { data } = await apiClient.get<PagedResponse<DeadlineRequest>>(BASE, {
    params: { ...toParams(query), page: query.page, size: query.size },
  })
  return data
}

/**
 * Talep durumu seçenekleri — `REFERANS(DEADLINE_UPDATE_REQUEST_STATUS)`'tan, `Accept-Language`'e göre
 * çözülmüş adlarla. Sabit üçlü liste **istemciye gömülmez**: kod tablosu analistindir, adı orada
 * değişince combo da değişir.
 */
export async function getDeadlineRequestStatuses(): Promise<DeadlineRequestStatusOption[]> {
  const { data } = await apiClient.get<DeadlineRequestStatusOption[]>(`${BASE}/statuses`)
  return data
}

/** Yeni termin güncelleme talebi oluşturur (aksiyon detayındaki pop-up'tan). */
export async function createDeadlineRequest(
  body: DeadlineRequestCreateInput,
): Promise<DeadlineRequest> {
  const { data } = await apiClient.post<DeadlineRequest>(BASE, body)
  return data
}

/** Talebi onaylar — aksiyonun **yalnız** termin tarihi güncellenir. */
export async function approveDeadlineRequest(
  id: number,
  body: DeadlineRequestApproveInput,
): Promise<DeadlineRequest> {
  const { data } = await apiClient.put<DeadlineRequest>(`${BASE}/${id}/approve`, body)
  return data
}

/** Talebi reddeder — aksiyona dokunulmaz. */
export async function rejectDeadlineRequest(
  id: number,
  body: DeadlineRequestRejectInput,
): Promise<DeadlineRequest> {
  const { data } = await apiClient.put<DeadlineRequest>(`${BASE}/${id}/reject`, body)
  return data
}
